module.exports = __webpack_public_path__ + "3fec058e4a0fab814bbe625c4483ed62.png";


//////////////////
// WEBPACK FOOTER
// ./img/upStock.png
// module id = 20
// module chunks = 9 11